import molin_11 from '../../assets/images/tra/molin_11.webp';
import molin_12 from '../../assets/images/tra/molin_12.webp';
import molin_13 from '../../assets/images/tra/molin_13.webp';
import molin_14 from '../../assets/images/tra/molin_14.webp';
import molin_15 from '../../assets/images/tra/molin_15.webp';
import molin_16 from '../../assets/images/tra/molin_16.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function TianlaiPavilion() {
    const [storyStatus, setStoryStatus] = useState(0);
    const [introductionStatus, setIntroductionStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>

            {storyStatus < 1 && (
                <div>
                    <img src={molin_11} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[51.6%] absolute left-[65.7%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className='text-[#000000] text-[2.6vw]' style={{ display: 'block' }}>天</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]" style={{ display: 'block' }}>籁</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]" style={{ display: 'block' }}>阁</span>
                            <span className="text-[#000000] text-[0.8vw] mt-[-0.4vw] ml-[0.2vw]" style={{ display: 'block' }}>Tianlai</span>
                            <span className="text-[#000000] text-[0.8vw] mt-[-0.4vw]" style={{ display: 'block' }}>Pavilion</span>
                        </div>
                    </div>
                    <div className="top-[38.5%] absolute left-[37.5%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[0.9vw] mt-[5.4vw] leading-[1.3vw] text-justify">根据史料《天籁阁帖》《墨林山人诗集》及后世著录如《石渠宝笈》，均以“天籁阁”指代项元汴的藏所与宅邸，项元汴因藏有一把刻有“天籁”二字的古琴，遂以其命名藏所，后成为其家族宅邸的核心象征。“天籁阁中藏晋唐巨迹，项氏之名传后世。”</span>
                            <span className="text-[#000000] text-[0.7vw] mt-[0.8vw] leading-[1vw] text-justify">According to historical records such as Tianlai Ge Tie (The Tianlai Pavilion Collection of Calligraphy), Molin Shanren Shiji (Poems of Master Molin), and later catalogues like Shiqubaoji (The Stone Channel Imperial Catalogue), the term "Tianlai Pavilion" consistently refers to Xiang Yuanbian's collection and residence. Xiang named his collection after it because he owned an ancient zither inscribed with the characters “Tianlai” (Celestial Music). The pavilion later became a central symbol of his family's estate. As recorded, “Within the Tianlai Pavilion lie masterpieces from the Jin and Tang dynasties; the Xiang family's name endures through posterity.”</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[19%] left-[47%] h-auto w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer animate-breathe-enter'
                        onClick={() => setStoryStatus(1)}>
                        <div className="flex flex-col text-center">
                            <span className="text-[#000000] text-[1.3vw]">进入</span>
                            <span className="text-[#000000] text-[1vw]">Enter</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus >= 1 && storyStatus < 3 && (
                <div>
                    <img src={molin_12} alt="Hero background" className="w-full h-auto" />
                    <div className='absolute bottom-[23%] left-[47%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div>
                    <img src={molin_13} alt="Hero background" className="w-full h-auto" />
                </div>
            )}
            {storyStatus === 5 && (
                <div>
                    <img src={molin_15} alt="Hero background" className="w-full h-auto" />
                    <div className='absolute bottom-[30%] left-[30%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 6 && (
                <div>
                    <img src={molin_16} alt="Hero background" className="w-full h-auto" />
                    <div className='absolute bottom-[20%] left-[42%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 4 && (
                <div>
                    <img src={molin_14} alt="Hero background" className="w-full h-auto" />
                    <div className='absolute bottom-[23%] left-[76%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus >= 1 && storyStatus < 3 && (
                <div className='absolute top-[40%] left-[15%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">庭院2</span>
                        <span className="text-[#000000] text-[0.8vw]">Family Garden 2</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => { setStoryStatus(3); setIntroductionStatus(0) }}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 1 && (
                <div className="top-[45%] left-[50%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(2)}>
                    </button>
                </div>
            )}
            {introductionStatus === 0 && storyStatus === 1 && storyStatus < 3 && (
                <div className="top-[16%] left-[85%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setIntroductionStatus(1)}>
                    </button>
                </div>
            )}
            {storyStatus >= 1 && storyStatus < 3 && (
                <div className='absolute top-[40%] left-[85%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">进入室内</span>
                        <span className="text-[#000000] text-[0.8vw]">Enter the room</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => { setStoryStatus(5); setIntroductionStatus(0) }}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div className='absolute top-[40%] left-[20%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">庭院3</span>
                        <span className="text-[#000000] text-[0.8vw]">Family Garden 3</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(4)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div className='absolute top-[70%] left-[85%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">返回庭院1</span>
                        <span className="text-[#000000] text-[0.8vw]">Back to Family Garden 1</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 4 && (
                <div className='absolute top-[25%] left-[35%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">返回庭院2</span>
                        <span className="text-[#000000] text-[0.8vw]">Back to Family Garden 2</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(3)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 5 && (
                <div className='absolute top-[10%] left-[55%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">返回庭院</span>
                        <span className="text-[#000000] text-[0.8vw]">Back to Family Garden</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 5 && (
                <div className="top-[50%] left-[50%] absolute">
                    <button className="rounded-[5vw] w-[10vw] h-[4vw] bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(6)}>
                        <div className='flex flex-col'>
                            <span className='text-[#000000] text-[1.3vw]'>赠送</span>
                            <span className='text-[#000000] text-[1vw] mt-[-0.4vw]'>Gift</span>
                        </div>
                    </button>
                </div>
            )}
            {storyStatus === 6 && (
                <div className='absolute top-[15%] left-[50%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer'>
                    <div className="flex flex-col text-center font-bold">
                        <span className="text-[#000000] text-[1vw]">返回庭院</span>
                        <span className="text-[#000000] text-[0.8vw]">Back to Family Garden</span>
                    </div>
                    <div className="absolute top-[3vw] left-[4vw] cursor-pointer">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(1)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 2 && (
                <div className={`chat-bubble-base absolute top-[20%] left-[48%] transform -translate-x-1/2 chat-bubble-right 
                        chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“诸位今日莅临，实乃寒舍之幸。昔人云‘独乐不如众乐’，今与诸君同赏笔墨丹青，共鉴藏品，方得其妙。”</span>
                    <span className='typing-effect'>"It is a great honor to have you all grace my humble abode today. As the ancients said, ‘True joy lies not in solitary possession but</span>
                    <span className='typing-effect'> in shared appreciation.' By appreciating these calligraphy and paintings together and discussing these treasures with you all, we</span>
                    <span className='mb-[1vw] typing-effect'>may truly grasp their essence."</span>
                </div>
            )}
            {introductionStatus === 1 && (
                <div>
                    <div className="top-[18%] absolute left-[57%] w-[26%] z-[8000]">
                        <div className="flex flex-col">
                            <span className='text-[#000000] text-[2.1vw]' style={{ display: 'block' }}>墨</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.8vw]" style={{ display: 'block' }}>林</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.8vw]" style={{ display: 'block' }}>堂</span>
                        </div>
                    </div>
                    <div className="top-[15%] absolute left-[61%] w-[16%] z-[8888] text-left">
                        <div className="flex flex-col">
                            <span className='text-[#000000] text-[0.8vw] leading-[1.3vw] text-justify'>“墨林”是项元汴的号，“墨林居士”，可以“墨林堂”命名其书房，以彰显其文人身份与艺术品味。“墨林堂中书画满壁，宾客盈门。”</span>
                            <span className="text-[#000000] text-[0.6vw] mt-[1vw] leading-[1vw] text-justify">"Molin" was Xiang Yuanbian's artistic name (hao), also known as "Master Molin." He named his study "Molin Hall" to symbolize his scholar’s identity and refined artistic taste. As the saying goes: "Calligraphy and paintings adorn the walls of Molin Hall; guests flock through its doors."</span>
                        </div>
                    </div>
                    <div className='top-[10%] absolute left-[55%] w-[25%] h-[30%] text-left rounded-[2vw]' style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)' }}></div>
                </div>
            )}
            {storyStatus === 5 && (
                <div className={`chat-bubble-base absolute top-[16%] left-[86%] transform -translate-x-1/2 chat-bubble-left 
                        chat-bubble-fade-in ${storyStatus >= 5 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“此碗为官窑所制，实属难得的精品！”</span>
                    <span className='mb-[1vw] typing-effect'>'This bowl was made in an official kiln and is a rare find!'</span>
                </div>
            )}
            {storyStatus === 5 && (
                <div className={`chat-bubble-base absolute top-[20%] left-[38%] transform -translate-x-1/2 chat-bubble-right 
                        chat-bubble-fade-in ${storyStatus >= 5 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“此碗为一故人所赠与，喜爱至极! ”</span>
                    <span className='mb-[1vw] typing-effect'>'This bowl was given to me by a deceased friend and loved it!'</span>
                </div>
            )}
            {storyStatus === 6 && (
                <div className={`chat-bubble-base absolute top-[40%] left-[95%] transform -translate-x-1/2 chat-bubble-left 
                        chat-bubble-fade-in ${storyStatus >= 6 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“知悉项兄尤爱古玩，准备了佳品瓷器作为项兄的生辰贺礼”</span>
                    <span className='typing-effect'>"I have learned that Brother Xiang has a particular fondness for antiques, </span>
                    <span className='mb-[1vw] typing-effect'>so I have prepared a fine piece of porcelain as a birthday gift for him."</span>
                </div>
            )}
            {storyStatus === 6 && (
                <div className={`chat-bubble-base absolute top-[25%] left-[43%] transform -translate-x-1/2 chat-bubble-right 
                        chat-bubble-fade-in ${storyStatus >= 6 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“贤弟厚意，墨林铭感五内。”</span>
                    <span className='typing-effect'>‘Sage brother's generous offer is deeply appreciated by Molin.’</span>
                </div>
            )}
            {storyStatus === 6 && (
                <div className={`chat-bubble-base absolute bottom-[10%] left-[98%] transform -translate-x-1/2
                    chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='text-center mt-[0.5vw] typing-effect'>友人的相互馈赠</span>
                    <span className='text-center mt-[0.2vw]  typing-effect'>项元汴的藏品中有一部分是来自友人的相互馈赠。其中例如：1564 年，</span>
                    <span className='text-center typing-effect'>丰坊为项元汴庆生作《临右军二帖扇面》；1578 年，文嘉为项元汴庆生</span>
                    <span className='text-center typing-effect'>作《山水图》。</span>
                    <span className='text-center my-[0.2vw] typing-effect'>Gifts Among Friends</span>
                    <span className='text-center typing-effect'>A portion of Xiang Yuanbian’s collection consists of mutually exchanged gifts from</span>
                    <span className='text-center typing-effect'>his friends. For example: In 1564, Feng Fang created The Two Letters of Wang Xizhi as</span>
                    <span className='text-center typing-effect'>a birthday gift for Xiang Yuanbian. In 1578, Wen Jia presented a Landscape Painting </span>
                    <span className='text-center mb-[0.5vw] typing-effect'>to Xiang Yuanbian for his birthday.</span>
                </div>
            )}
        </div>
    )
}